import React from "react";
import styles from "./FeaturesSection.module.css";
import { NavLink } from "react-router-dom";
import { injectIntl, FormattedMessage } from "react-intl";
import VideoPlayer from "../components/VideoPlayer";
import ScrollReveal from "../components/ScrollReveal";
import { FaCheck } from "react-icons/fa";

const stats = [
  { value: "10k+", labelId: "features.stat1.label", labelDefault: "Projetos analisados" },
  { value: "98%",  labelId: "features.stat2.label", labelDefault: "Precisão nos relatórios" },
  { value: "3min", labelId: "features.stat3.label", labelDefault: "Tempo médio de geração" }
];

const checkItems = [
  { id: "features.check1", def: "Detecção automática de anomalias e falhas estruturais" },
  { id: "features.check2", def: "Tabelas de medições e áreas calculadas automaticamente" },
  { id: "features.check3", def: "Relatório em PDF pronto para entregar ao cliente" }
];

const FeaturesSection = ({ intl }) => {
  return (
    <section id="relatorios-ia" className={styles.features}>
      <div className={styles.container}>
        <ScrollReveal>
          <div className={styles.sectionLabel}>
            <span className={styles.labelLine} />
            <FormattedMessage id="features.label" defaultMessage="IA integrada" />
            <span className={styles.labelLine} />
          </div>
          <h2 className={styles.sectionTitle}>
            <FormattedMessage id="features.sectionTitle" />
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={80}>
          <div className={styles.featureLayout}>
            {/* Video side */}
            <div className={styles.featureMedia}>
              <div className={styles.featureVideoFrame}>
                <div className={styles.featureFrameChrome}>
                  <div className={styles.featureFrameDots}>
                    <span /><span /><span />
                  </div>
                  <div className={styles.featureFrameUrl}>vertex4d.ai — Relatório de Análise</div>
                </div>
                <div className={styles.featureVideoWrap}>
                  <VideoPlayer
                    videoId="RCB_pgFk8SI"
                    title={intl.formatMessage({ id: "features.reports.title" })}
                  />
                </div>
              </div>
              {/* Stats strip below video */}
              <div className={styles.statsStrip}>
                {stats.map((s, i) => (
                  <div key={i} className={styles.statItem}>
                    <span className={styles.statValue}>{s.value}</span>
                    <span className={styles.statLabel}>
                      <FormattedMessage id={s.labelId} defaultMessage={s.labelDefault} />
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Content side */}
            <div className={styles.featureContent}>
              <h3 className={styles.featureTitle}>
                <FormattedMessage id="features.reports.title" />
              </h3>
              <p className={styles.featureDescription}>
                <FormattedMessage id="features.reports.description" />
              </p>

              <ul className={styles.checkList}>
                {checkItems.map(item => (
                  <li key={item.id} className={styles.checkItem}>
                    <span className={styles.checkIcon}><FaCheck size={11} /></span>
                    <FormattedMessage id={item.id} defaultMessage={item.def} />
                  </li>
                ))}
              </ul>

              <NavLink to="/analise" className={styles.featureBtn}>
                <FormattedMessage id="features.button" />
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </NavLink>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default injectIntl(FeaturesSection);
